// extracted by mini-css-extract-plugin
module.exports = {"centerHorizontally":"_27iRk","centerVertically":"_2YAto","wrapper":"_6wZ8t","white":"VmlmB","yellow":"_2jeMK","loader":"_10z0O"};